import { Pipe, PipeTransform } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';
import { Address } from '../contract/address.contract';

@Pipe({
  name: 'address',
  standalone: true,
})
export class AddressPipe implements PipeTransform {
  transform(address: Address | Nullable): string {
    if (!address) return '';

    const typedAddress = address;

    let street = typedAddress?.street ?? '';
    const streetNumber = typedAddress?.streetNumber ?? '';
    const postalCode = typedAddress?.postalCode ?? '';
    const city = typedAddress?.city ?? '';

    if (street) {
      if (streetNumber) {
        street += ' ' + streetNumber.trim();
      }
      street += ',';
    }

    const concatenatedAddress = `${street ?? ''} ${postalCode ?? ''} ${city ?? ''}`.trim();
    return this.removeMultipleSpaces(concatenatedAddress);
  }

  private removeMultipleSpaces(value: string) {
    return value.replace(/\s\s+/g, ' ');
  }
}
